import React from 'react';
import Select from 'react-select';

export default class TimesheetDetailPhaseSelect extends React.Component {
    onContractPhaseChange = (contractPhase) => {
        const {
            dailyTimesheetDetail,
            dailyTimesheet,
            onDailyTimesheetMutated,
        } = this.props;

        dailyTimesheet.dailyTimesheetDetails.forEach((dtd) => {
            if (dtd != dailyTimesheetDetail) {
                return;
            }

            dtd.contractPhaseId = contractPhase ? contractPhase.id : null;
        });

        onDailyTimesheetMutated(dailyTimesheet);
    };

    render() {
        const { contract, dailyTimesheetDetail, readOnly } = this.props;

        if (!contract || !contract.contractPhases) {
            return <>No Phases</>;
        }

        return (
            <Select
                options={contract.contractPhases}
                getOptionLabel={(cp) =>
                    `${cp.displayPhase} - ${cp.description}`
                }
                getOptionValue={(cp) => cp.id}
                onChange={this.onContractPhaseChange}
                value={
                    contract.contractPhases.find(
                        (cp) => cp.id == dailyTimesheetDetail.contractPhaseId
                    ) || ''
                }
                isClearable={true}
                isDisabled={readOnly}
            />
        );
    }
}
